import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";
import { AuthGuardService } from "app/shared/auth-guard.service";
import { canDeactivateGuard } from "app/shared/can-deactivate-guard.service";
import { EntityManagerProviderGuard } from "app/shared/entity-manager-guard";
import { SharedModule } from "app/shared/shared.module";
import { NotepadHomeComponent } from "./notepad-home.component";
import { NotepadLayoutComponent } from "./notepad-layout.component";
import { NotepadPullBatchesComponent } from "./notepad-pull-batches.component";
import { NotepadPrinterDialogComponent } from "./notepad-printer-dialog.component";
import { NotepadPullApplyComponent } from "./notepad-pull-apply.component";
import { NotepadPullComponent } from "./notepad-pull.component";

export const routes: Routes = [
  {
    path: "notepad",
    component: NotepadLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: NotepadHomeComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
      },
      {
        path: "pull-batches",
        component: NotepadPullBatchesComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
      },
      {
        path: "pull/:joPullBatchId",
        component: NotepadPullComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
        // Waits for Mark Complete / Uncomplete (wrapBusy) before the page is left.
        canDeactivate: [canDeactivateGuard],
      },
      {
        path: "pull/:joPullBatchId/apply/:joDetailId/:shouldPrintBarcodes",
        component: NotepadPullApplyComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
      },
    ],
  },
];

@NgModule({
  declarations: [
    NotepadLayoutComponent,
    NotepadHomeComponent,
    NotepadPullBatchesComponent,
    NotepadPullComponent,
    NotepadPullApplyComponent,
    NotepadPrinterDialogComponent,
  ],
  imports: [SharedModule],
})
export class NotepadModule {}
